import { ref } from 'vue'
import { defineStore } from 'pinia'
import countriesData from '@/store/data/countries'
import countryLocalesData from '@/store/data/countryLocales'

export const useAddressStore = defineStore('AddressStore', () => {
  const countries = ref(countriesData)
  const countryLocales = ref(countryLocalesData)

  return {
    countries,
    countryLocales
  }
})
